import gsap from"gsap";
const duration = 5;
const activeClass = "slider__slides__item--active";

export default function initSlider(){
    const sliders = document.querySelectorAll(".slider");

    sliders.forEach(slider => {
        let sliderTimeout = undefined;

        const panels = slider.querySelectorAll(".slider__slides__item");
        const bar = slider.querySelector(".slider__dots__bar");
        const dotCont = slider.querySelector(".slider__dots");

        panels[0].classList.add(activeClass);

        for(let i = 0; i < panels.length; i++){
            const dot = document.createElement("button");
            dot.classList.add("slider__dots__item");

            dotCont?.appendChild(dot);

            dot.addEventListener("click", function (){
                panels.forEach(panel => panel.classList.remove(activeClass));
                panels[i].classList.add(activeClass);

                sliderTimeout.progress((i / panels.length));
            });
        }

        if(sliderTimeout) sliderTimeout.kill();

        const tl = gsap.timeline();
        sliderTimeout = tl.fromTo(bar, { x: -100 + "%" }, {
            x: 0 + "%",
            duration: duration * (panels.length),
            ease: "linear",

            onUpdate: () => {
                if(sliderTimeout){
                    const progress = sliderTimeout.progress();

                    if(progress !== 1){
                        panels[Math.floor(progress / (1 / panels.length))].classList.add(activeClass);
                    }
                }
            },

            onComplete: () => {
                sliderTimeout.kill();

                panels.forEach(panel => panel.classList.remove(activeClass));
                panels[0].classList.add(activeClass);

                gsap.to(bar, {
                    x: -100 + "%",
                    duration: 2,

                    onComplete: () => { tl.restart(); }
                });
            }
        });
    });
}